export default {
  // Form related
  'ens.form.title': 'ENS Filing',
  'ens.form.submit': 'Submit',
  'ens.form.master_bl': 'Master B/L No.',
  'ens.form.mot': 'Mode of Transport',
  'ens.form.mot.ocean': 'Ocean',
  'ens.form.mot.air': 'Air',
  'ens.form.mot.rail': 'Rail',
  'ens.form.mot.truck': 'Truck',
  'ens.form.consignment_type': 'Consignment Type',
  'ens.form.consignment_type.fcl': 'FCL',
  'ens.form.consignment_type.lcl': 'LCL',
  'ens.form.consignment_type.ncl': 'NCL',
  'ens.form.filing_type': 'Filing Type',
  'ens.form.filing_type.import': 'I - Import',
  'ens.form.filing_type.frob': 'F - Freight Remain on Board',
  'ens.form.filing_type.intransit': 'S - In-Transit',
  'ens.form.vessel': 'Vessel Name',
  'ens.form.vessel_imo': 'IMO Number',
  'ens.form.voyage': 'Voyage',
  'ens.form.port_of_loading': 'Port of Loading',
  'ens.form.port_of_loading_code': 'Port of Loading Code',
  'ens.form.port_of_discharge': 'Port of Discharge',
  'ens.form.port_of_discharge_code': 'Port of Discharge Code',
  'ens.form.eta': 'ETA',
  'ens.form.etd': 'ETD',
  'ens.form.addressed_member_state': 'Addressed Member State',
  'ens.field.addressed_member_state.placeholder': 'Select EU member state',

  // Carrier fields
  'ens.field.carrier': 'Carrier',

  // Field sections
  'ens.field.master': 'Master Information',
  'ens.field.route_information': 'Route Information',
  'ens.field.hbl': 'HBL Information',
  'ens.field.conveyance': 'Conveyance Information',
  'ens.field.arrival_vessel': 'Arrival Vessel',
  'ens.field.containers': 'Containers',
  'ens.field.goods_items': 'Goods Items',
  'ens.field.route_countries': 'Route Countries',

  // HBL fields
  'ens.field.hbl.house_no': 'House No',
  'ens.field.hbl.payment_method': 'Payment Method',
  'ens.field.hbl.place_of_receipt': 'Place of Receipt',
  'ens.field.hbl.place_of_delivery': 'Place of Delivery',
  'ens.field.hbl.shipper': 'Shipper',
  'ens.field.hbl.consignee': 'Consignee',
  'ens.field.hbl.notify': 'Notify',
  'ens.field.hbl.seller': 'Seller',
  'ens.field.hbl.seller.required': 'Seller is required when not self-filing',
  'ens.field.hbl.buyer': 'Buyer',
  'ens.field.hbl.buyer.required': 'Buyer is required when not self-filing',

  // Conveyance fields
  'ens.field.conveyance.name': 'Conveyance Name',
  'ens.field.conveyance.id_type': 'ID Type',
  'ens.field.conveyance.id_type.placeholder': 'Select ID type',
  'ens.field.conveyance.id': 'ID',
  'ens.field.conveyance.imo': 'IMO Number',
  'ens.field.conveyance.wagon_no': 'Wagon Number',
  'ens.field.conveyance.train_no': 'Train Number',
  'ens.field.conveyance.vehicle_reg': 'Road Vehicle Registration',
  'ens.field.conveyance.trailer_reg': 'Road Trailer Registration',
  'ens.field.conveyance.aircraft_reg': 'Aircraft Registration',
  'ens.field.conveyance.eni_code': 'ENI Code',
  'ens.field.conveyance.number': 'Number',
  'ens.field.conveyance.flag': 'Vessel Flag State',
  'ens.field.conveyance.transport_means': 'Transport Means',
  'ens.field.conveyance.transport_means.placeholder': 'Select transport means',

  // Arrival Vessel fields
  'ens.field.arrival_vessel.name': 'Vessel Name',
  'ens.field.arrival_vessel.imo': 'IMO Number',
  'ens.field.arrival_vessel.number': 'Voyage',
  'ens.field.arrival_vessel.flag': 'Vessel Flag State',

  // Other fields
  'ens.field.final_destination': 'Final Destination',
  'ens.field.route_countries.placeholder': 'Select countries',

  // Filing fields
  'ens.field.filing.coload_indicator': 'Coload In Self Filing',
  'ens.field.filing.supplementary_declarants': 'Supplementary Declarants',
  'ens.field.filing.supplementary_declarant': 'Add Supplementary Declarant',
  'ens.field.filing.add_declarant': 'Add Declarant',
  'ens.field.filing.edit_declarant': 'Edit Supplementary Declarant',
  'ens.field.filing.declarant_contact': 'Contact',
  'ens.field.filing.bl_type': 'BL Type',
  'ens.field.filing.bl_type.house': '1 - House level filing',
  'ens.field.filing.bl_type.sub_house': '2 - Sub-house level filing',
  'ens.field.filing.supplementary_declarant.required':
    'At least one Supplementary Declarant is required when self-filing',

  // Sections
  'ens.section.containers_goods': 'Containers & Goods',
  'ens.section.additional': 'Additional Information',
  'ens.section.additional.placeholder': 'Additional information features to be implemented',

  // Container fields
  'ens.field.containers.add': 'Add Container',

  // Goods Items fields

  'ens.field.goods_items.add': 'Add Goods Item',

  // Tabs
  'ens.tab.info': 'Info',
  'ens.tab.documents': 'Documents',

  // Actions
  'ens.report': 'Report',

  // EORI fields
  'ens.form.filer_code': 'Filer Code (EORI)',
  'ens.form.representative_eori': 'Representative EORI',

  // List related
  'ens.list.ext_id': 'ENS No.',
  'ens.list.mrn': 'MRN',
  'ens.list.status': 'Status',
  'ens.list.filer_code': 'Filer Code',
  'ens.list.mbl_no': 'Master B/L No.',
  'ens.list.mot': 'Mode of Transport',
  'ens.list.vessel': 'Vessel Name',
  'ens.list.voyage': 'Voyage',
  'ens.list.port_of_loading': 'Port of Loading',
  'ens.list.port_of_discharge': 'Port of Discharge',
  'ens.list.eta': 'ETA',
  'ens.list.etd': 'ETD',
  'ens.list.last_submitted_at': 'Last Submitted',
  'ens.list.last_disposition': 'Last Disposition',
  'ens.list.new': 'New ENS',

  // Status related
  'ens.status.new': 'New',
  'ens.status.submitted': 'Submitted',
  'ens.status.received': 'Received',
  'ens.status.rejected': 'Rejected',
  'ens.status.accepted': 'Accepted',
  'ens.status.amended': 'Amended',
  'ens.status.invalidated': 'Invalidated',

  // Mode of Transport
  'ens.mot.ocean': 'Ocean',
  'ens.mot.air': 'Air',
  'ens.mot.rail': 'Rail',
  'ens.mot.truck': 'Truck',

  // Messages
  'ens.save.success': 'ENS saved successfully',
  'ens.save.error': 'Failed to save ENS',
  'ens.update.success': 'ENS updated successfully',
  'ens.submit.success': 'ENS submitted successfully',
  'ens.submit.error': 'Failed to submit ENS',
  'ens.submit.save_first': 'Please save the ENS first before submitting',
};
